// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__2fgW6"};